<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <div class="main_content">
      <div class="container-fluid">
        <div class="index-top-info"></div>
        <div class="clearfix"></div>
        <div class="row">
          <div class="col-12">
            <div class="index-item">
              <b-container fluid>
                <!-- <b-row>
                                    <b-col cols="12">
                                        <p>*以下資料皆屬於假資料</p>
                                    </b-col>
                                </b-row> -->
                <b-row style="margin-bottom: 5px;">
                  <b-col cols="auto">
                    查詢起訖時間:
                  </b-col>
                  <b-col cols="10">
                    <b-input-group style="width: 8rem; display: inline-flex;">
                      <b-input-group-prepend is-text>
                        <b-icon icon="calendar3"></b-icon>
                      </b-input-group-prepend>
                      <b-form-select
                        style="width: 3rem;"
                        v-model="timepicker.minvalue"
                        :options="yearselection.startyear.options"
                      ></b-form-select>
                      <!-- <datepicker
                        style="width: 13vh;"
                        v-model="timepicker.minvalue"
                        min="1960-01-01"
                        :max="twtimeparse(timepicker.maxvalue)"
                      ></datepicker> -->
                    </b-input-group>
                    <span
                      style="display: inline-flex; margin-left: 0.5rem; margin-right: 0.5rem;"
                      >~</span
                    >
                    <b-input-group style="width: 8rem; display: inline-flex;">
                      <b-input-group-prepend is-text>
                        <b-icon icon="calendar3"></b-icon>
                      </b-input-group-prepend>
                      <b-form-select
                        style="width: 3rem;"
                        v-model="timepicker.maxvalue"
                        :options="yearselection.endyear.options"
                      ></b-form-select>
                      <!-- <datepicker
                        v-model="timepicker.maxvalue"
                        style="width: 13vh;"
                        :min="twtimeparse(timepicker.minvalue)"
                        :max="timepicker.max"
                      ></datepicker> -->
                    </b-input-group>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 5px;">
                  <b-col cols="auto">
                    期作:
                  </b-col>
                  <b-col cols="10">
                    <b-form-select
                      style="min-width: 10vh; width:fit-content;"
                      v-model="ricefarm.periodselected"
                      :options="ricefarm.periodoptions"
                    ></b-form-select>
                  </b-col>
                </b-row>
                <template v-if="ricefarm.townoptions.length > 0">
                  <b-row style="margin-bottom: 5px;">
                    <b-col cols="auto">
                      鄉鎮別:
                    </b-col>
                    <b-col cols="10">
                      <b-form-select
                        style="min-width: 10vh; width:fit-content;"
                        v-model="ricefarm.townselected"
                        :options="ricefarm.townoptions"
                      ></b-form-select>
                    </b-col>
                  </b-row>
                </template>
              </b-container>
              <!-- <b-overlay :show="ricefarm.ifchartshow" rounded="sm"> -->
              <div style="width: 100%;">
                <apexchart
                  ref="chart1ref"
                  type="line"
                  height="450"
                  :options="ricefarm.obj.chart.options"
                  :series="ricefarm.obj.chart.series"
                ></apexchart>
              </div>
              <!-- <div>※值為0代表無資料</div> -->
              <!-- </b-overlay> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </b-overlay> -->
  </b-container>
</template>

<script>
// import datepicker from "@/components/Datepicker.vue";

export default {
  data() {
    var date = new Date();
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    // maxDate.setDate(date.getDate() + 1);
    const minDate = new Date(today);
    minDate.setDate(date.getDate() - 30);
    var taiwanMinDate = minDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMinDate[0] = parseInt(taiwanMinDate[0]) - 1911;
    taiwanMinDate[1] =
      taiwanMinDate[1].length == 1 ? 0 + taiwanMinDate[1] : taiwanMinDate[1];
    taiwanMinDate[2] =
      taiwanMinDate[2].length == 1 ? 0 + taiwanMinDate[2] : taiwanMinDate[2];
    var taiwanMaxDate = maxDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
      taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    taiwanMaxDate[2] =
      taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
      ricefarm: {
        ricefarmlist: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
          items: [],
          allitems: [
            {
              DATE: "110-06-07",
              PEROID: "001",
              TOWNCATEGORY: "水上鄉",
              PURCHASEUNIT: "水上鄉農會",
              PURCHASE: 71,
              MINPRICE: 910,
              MAXPRICE: 930,
            },
            {
              DATE: "110-06-07",
              PEROID: "001",
              TOWNCATEGORY: "水上鄉",
              PURCHASEUNIT: "順利糧食有限公司",
              PURCHASE: 63,
              MINPRICE: 730,
              MAXPRICE: 840,
            },
            {
              DATE: "110-06-07",
              PEROID: "002",
              TOWNCATEGORY: "水上鄉",
              PURCHASEUNIT: "水上鄉農會",
              PURCHASE: 75,
              MINPRICE: 900,
              MAXPRICE: 950,
            },
            {
              DATE: "110-06-07",
              PEROID: "002",
              TOWNCATEGORY: "水上鄉",
              PURCHASEUNIT: "順利糧食有限公司",
              PURCHASE: 70,
              MINPRICE: 560,
              MAXPRICE: 880,
            },
            {
              DATE: "110-06-07",
              PEROID: "001",
              TOWNCATEGORY: "民雄鄉",
              PURCHASEUNIT: "順利糧食有限公司",
              PURCHASE: 68,
              MINPRICE: 850,
              MAXPRICE: 900,
            },
            {
              DATE: "110-06-07",
              PEROID: "002",
              TOWNCATEGORY: "民雄鄉",
              PURCHASEUNIT: "順利糧食有限公司",
              PURCHASE: 450,
              MINPRICE: 940,
              MAXPRICE: 1050,
            },
            {
              DATE: "110-06-07",
              PEROID: "001",
              TOWNCATEGORY: "民雄鄉",
              PURCHASEUNIT: "水上鄉農會",
              PURCHASE: 120,
              MINPRICE: 250,
              MAXPRICE: 750,
            },
            {
              DATE: "110-06-07",
              PEROID: "002",
              TOWNCATEGORY: "民雄鄉",
              PURCHASEUNIT: "水上鄉農會",
              PURCHASE: 440,
              MINPRICE: 860,
              MAXPRICE: 1120,
            },
            {
              DATE: "110-06-08",
              PEROID: "001",
              TOWNCATEGORY: "水上鄉",
              PURCHASEUNIT: "水上鄉農會",
              PURCHASE: 115,
              MINPRICE: 970,
              MAXPRICE: 1050,
            },
            {
              DATE: "110-06-08",
              PEROID: "001",
              TOWNCATEGORY: "水上鄉",
              PURCHASEUNIT: "順利糧食有限公司",
              PURCHASE: 78,
              MINPRICE: 870,
              MAXPRICE: 940,
            },
            {
              DATE: "110-06-08",
              PEROID: "002",
              TOWNCATEGORY: "水上鄉",
              PURCHASEUNIT: "水上鄉農會",
              PURCHASE: 68,
              MINPRICE: 785,
              MAXPRICE: 987,
            },
            {
              DATE: "110-06-08",
              PEROID: "002",
              TOWNCATEGORY: "水上鄉",
              PURCHASEUNIT: "順利糧食有限公司",
              PURCHASE: 112,
              MINPRICE: 680,
              MAXPRICE: 980,
            },
            {
              DATE: "110-06-08",
              PEROID: "001",
              TOWNCATEGORY: "民雄鄉",
              PURCHASEUNIT: "順利糧食有限公司",
              PURCHASE: 105,
              MINPRICE: 967,
              MAXPRICE: 1120,
            },
            {
              DATE: "110-06-08",
              PEROID: "002",
              TOWNCATEGORY: "民雄鄉",
              PURCHASEUNIT: "順利糧食有限公司",
              PURCHASE: 550,
              MINPRICE: 658,
              MAXPRICE: 1284,
            },
            {
              DATE: "110-06-08",
              PEROID: "001",
              TOWNCATEGORY: "民雄鄉",
              PURCHASEUNIT: "水上鄉農會",
              PURCHASE: 130,
              MINPRICE: 820,
              MAXPRICE: 930,
            },
            {
              DATE: "110-06-08",
              PEROID: "002",
              TOWNCATEGORY: "民雄鄉",
              PURCHASEUNIT: "水上鄉農會",
              PURCHASE: 320,
              MINPRICE: 820,
              MAXPRICE: 1080,
            },
            {
              DATE: "110-06-09",
              PEROID: "001",
              TOWNCATEGORY: "水上鄉",
              PURCHASEUNIT: "水上鄉農會",
              PURCHASE: 113,
              MINPRICE: 890,
              MAXPRICE: 1040,
            },
            {
              DATE: "110-06-09",
              PEROID: "001",
              TOWNCATEGORY: "水上鄉",
              PURCHASEUNIT: "順利糧食有限公司",
              PURCHASE: 88,
              MINPRICE: 1020,
              MAXPRICE: 1170,
            },
            {
              DATE: "110-06-09",
              PEROID: "002",
              TOWNCATEGORY: "水上鄉",
              PURCHASEUNIT: "水上鄉農會",
              PURCHASE: 95,
              MINPRICE: 784,
              MAXPRICE: 988,
            },
            {
              DATE: "110-06-09",
              PEROID: "002",
              TOWNCATEGORY: "水上鄉",
              PURCHASEUNIT: "順利糧食有限公司",
              PURCHASE: 134,
              MINPRICE: 860,
              MAXPRICE: 1060,
            },
            {
              DATE: "110-06-09",
              PEROID: "001",
              TOWNCATEGORY: "民雄鄉",
              PURCHASEUNIT: "順利糧食有限公司",
              PURCHASE: 110,
              MINPRICE: 850,
              MAXPRICE: 1200,
            },
            {
              DATE: "110-06-09",
              PEROID: "002",
              TOWNCATEGORY: "民雄鄉",
              PURCHASEUNIT: "順利糧食有限公司",
              PURCHASE: 450,
              MINPRICE: 900,
              MAXPRICE: 1300,
            },
            {
              DATE: "110-06-09",
              PEROID: "001",
              TOWNCATEGORY: "民雄鄉",
              PURCHASEUNIT: "水上鄉農會",
              PURCHASE: 185,
              MINPRICE: 250,
              MAXPRICE: 780,
            },
            {
              DATE: "110-06-09",
              PEROID: "002",
              TOWNCATEGORY: "民雄鄉",
              PURCHASEUNIT: "水上鄉農會",
              PURCHASE: 220,
              MINPRICE: 780,
              MAXPRICE: 1090,
            },
          ],
        },
        marketlist: {
          value: [],
          options: [],
          allitems: [],
          items: [],
        },
        speclist: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
          items: [],
        },
        periodoptions: [
          { text: "請選擇", value: null },
          { text: "第一期", value: "001" },
          { text: "第二期", value: "002" },
        ],
        periodselected: null,
        townoptions: [
          //{ text: '請選擇', value: null },
          // { text: "太保市", value: "太保市" },
          // { text: "朴子市", value: "朴子市" },
          // { text: "布袋鎮", value: "布袋鎮" },
          // { text: "大林鎮", value: "大林鎮" },
          // { text: "民雄鄉", value: "民雄鄉" },
          // { text: "溪口鄉", value: "溪口鄉" },
          // { text: "新港鄉", value: "新港鄉" },
          // { text: "六腳鄉", value: "六腳鄉" },
          // { text: "東石鄉", value: "東石鄉" },
          // { text: "義竹鄉", value: "義竹鄉" },
          // { text: "鹿草鄉", value: "鹿草鄉" },
          // { text: "水上鄉", value: "水上鄉" },
          // { text: "中埔鄉", value: "中埔鄉" },
          // { text: "竹崎鄉", value: "竹崎鄉" },
          // { text: "梅山鄉", value: "梅山鄉" },
          // { text: "番路鄉", value: "番路鄉" },
          // { text: "大埔鄉", value: "大埔鄉" },
          // { text: "阿里山鄉", value: "阿里山鄉" }
        ],
        townlist: [
          { text: "水上鄉", value: "水上鄉" },
          { text: "太保市", value: "太保市" },
          { text: "民雄鄉", value: "民雄鄉" },
          { text: "新港鄉", value: "新港鄉" },
          { text: "大林鎮", value: "大林鎮" },
          { text: "朴子市", value: "朴子市" },
          { text: "溪口鄉", value: "溪口鄉" },
          { text: "六腳鄉", value: "六腳鄉" },
          { text: "義竹鄉", value: "義竹鄉" },
          { text: "鹿草鄉", value: "鹿草鄉" },
        ],
        // purchaseunitselected: null,
        // purchaseunitoptions:
        // [
        //     { text: '請選擇', value: null },
        //     { text: "水上鄉農會", value: "水上鄉農會" },
        //     { text: "順利糧食有限公司", value: "順利糧食有限公司" },
        // ],
        townselected: null,
        iffirst: true,
        ifchartshow: false,
        averageprice: false,
        maintainprice: false,
        overylayshow: true,
        selectlist: [0, "梨子", null],
        typeoptionslist: [
          { text: "請選擇種類", value: null, disabled: true },
          { text: "水果", value: 0 },
          { text: "蔬菜", value: 1 },
          { text: "雜糧特作", value: 2 },
        ],
        options: [
          { text: "請選擇作物", value: null },
          { text: "梨子", value: "梨子" },
          { text: "木瓜", value: "木瓜" },
          { text: "鳳梨", value: "鳳梨" },
        ],
        obj: {
          chart: {
            series: [],
            options: {
              chart: {
                height: 450,
                //width: 1800,
                type: "line",
                zoom: {
                  enabled: false,
                },
              },
              title: {
                text: "",
              },
              dataLabels: {
                enabled: true,
              },
              noData: {
                text: "請選擇期作",
                align: "center",
                verticalAlign: "middle",
              },
              xaxis: {
                categories: [],
                type: "date",
              },
              yaxis: [],
              colors: [
                "#008FFB",
                "#19535f",
                "#FEB019",
                "#FF4560",
                "#775DD0",
                "#1c22ce",
                "#ff7b3d",
                "#f9b5c0",
                "#4c1a11",
              ],
              plotOptions: {
                bar: {
                  columnWidth: "20%",
                },
              },
            },
          },
        },
      },
      yearselection: {
        startyear: {
          value: null,
          options: [],
        },
        endyear: {
          value: null,
          options: [],
        },
      },
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "產銷儀錶板",
          active: true,
        },
        {
          text: "稻作交易價量分析",
          active: true,
        },
      ],
      timepicker: {
        minvalue: taiwanMinDate.join("-"),
        maxvalue: taiwanMaxDate.join("-"),
        // minvalue: "110-06-07",
        // maxvalue: "110-06-11",
        max: maxDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
        //min: minDate.toLocaleString().split(' ')[0].split('/').join('-')
      },
      croplandlist: [],
      apiTownFromRiceFarm: (data) =>
        this.userRequest.post("/API/Default/getTownFromRiceFarm", data),
      apiRiceFarmForChart: (data) =>
        this.userRequest.post("/API/Default/getRiceFarmForChart ", data),
    };
  },
  created() {
    this.checkLogin();
    // this.init();
  },
  // components: {
  //   datepicker,
  // },
  computed: {
    state() {
      return this.ricefarm.marketlist.value.length > 3 ? false : null;
    },
  },
  // mounted(){
  //     // this.FunctionToken(this.getCropLandList, {});

  // },
  watch: {
    "timepicker.maxvalue"() {
      if (this.ricefarm.periodselected != null) {
        this.init();
      }
    },
    "timepicker.minvalue"() {
      if (this.ricefarm.periodselected != null) {
        this.init();
      }
    },
    "ricefarm.periodselected"() {
      if (this.ricefarm.periodselected != null) {
        // let localmintime = this.timepicker.minvalue.split("-");
        // localmintime[0] = parseInt(localmintime[0]) + 1911;
        // let localmaxtime = this.timepicker.maxvalue.split("-");
        // localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;
        // let diff = Math.floor(
        //   (Date.parse(localmaxtime.join("-")) -
        //     Date.parse(localmintime.join("-"))) /
        //     86400000
        // );
        // if (diff > 31) {
        //   alert("時間選擇區間不能超過1個月");
        // } else {
        this.init();
        // }
      }
    },
    "ricefarm.townselected"() {
      this.checkoption();
    },
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      let data = { PJ_ID: "PJ000000000005", fun: this.checkByPJID };
      this.FunctionToken(this.Authority, data);
    },
    checkByPJID(value) {
      if (!value) {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      } else {
        this.getyearlist();
      }
      //   else {
      //     // window.addEventListener("resize", this.handleResize);
      //     // this.handleResize();
      //     this.init();
      //   }
    },
    getyearlist() {
      let nowday = new Date();
      let year = nowday.getFullYear();
      let list = [];
      for (let y = year; y >= 2017; y--) {
        let subdate = y - 1911;
        list.push(subdate);
      }
      this.yearselection.startyear.options = list;
      this.yearselection.endyear.options = list;
      this.timepicker.minvalue = list[0];
      this.timepicker.maxvalue = list[0];
    },
    getTownListFromRiceFarm(data) {
      this.apiTownFromRiceFarm(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let item = JSON.parse(json.Data);
            this.ricefarm.townoptions = [];
            this.ricefarm.townselected = null;
            if (item.length > 0) {
              item.forEach((x) => {
                let obj = {
                  text: x.RF_TOWN,
                  value: x.RF_TOWN,
                };
                this.ricefarm.townoptions.push(obj);
              });
            }
            this.ricefarm.townoptions.unshift({ text: "請選擇", value: null });
          }
        })
        .catch((err) => console.warn(err));
    },
    getDataforChart(data) {
      this.apiRiceFarmForChart(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let item = JSON.parse(json.Data);
            this.ricefarm.ricefarmlist.items = [];
            item.forEach((x) => {
              if (x.RF_DELETE == 0) {
                this.ricefarm.ricefarmlist.items.push(x);
              }
            });
            this.createtestchart();
          }
        })
        .catch((err) => console.warn(err));
    },
    init() {
      this.ricefarm.ricefarmlist.items = [];

      let obj = {
        start_year: this.timepicker.minvalue,
        end_year: this.timepicker.maxvalue,
        RF_PERIOD: this.ricefarm.periodselected,
      };

      this.FunctionToken(this.getTownListFromRiceFarm, obj);
      // let localmintime = this.timepicker.minvalue.split("-");
      // localmintime[0] = parseInt(localmintime[0]) + 1911;
      // let localmaxtime = this.timepicker.maxvalue.split("-");
      // localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;
      // this.chartinit();

      // let diff = Math.floor(
      //   (Date.parse(localmaxtime.join("-")) -
      //     Date.parse(localmintime.join("-"))) /
      //     86400000
      // );

      // if (diff <= 30) {
      //   let obj = {
      //     start_date: localmintime.join("-"),
      //     end_date: localmaxtime.join("-"),
      //     RF_PERIOD: this.ricefarm.periodselected,
      //   };
      //   this.FunctionToken(this.getTownListFromRiceFarm, obj);
      // }
    },
    chartinit() {
      this.ricefarm.obj.chart.series = [];
      this.ricefarm.obj.chart.options.labels = [];
      this.ricefarm.obj.chart.options.yaxis = [];
    },
    checkoption() {
      if (
        this.ricefarm.periodselected != null &&
        this.ricefarm.townselected != null
      ) {
        // let localmintime = this.timepicker.minvalue.split("-");
        // localmintime[0] = parseInt(localmintime[0]) + 1911;
        // let localmaxtime = this.timepicker.maxvalue.split("-");
        // localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;
        // let obj = {
        //   start_date: localmintime.join("-"),
        //   end_date: localmaxtime.join("-"),
        //   RF_PERIOD: this.ricefarm.periodselected,
        //   RF_TOWN: this.ricefarm.townselected,
        // };
        let obj = {
          start_year: this.timepicker.minvalue,
          end_year: this.timepicker.maxvalue,
          RF_PERIOD: this.ricefarm.periodselected,
          RF_TOWN: this.ricefarm.townselected,
        };
        this.FunctionToken(this.getDataforChart, obj);
        //
      }
    },
    createtestchart() {
      this.ricefarm.obj.chart.series = [];
      this.ricefarm.obj.chart.options.labels = [];
      this.ricefarm.obj.chart.options.yaxis = [];
      let mainlist = [],
        serieslist = [],
        unique = [];
      let datelist = [
        ...new Set(
          this.ricefarm.ricefarmlist.items.map((item) => item.RF_CDATE)
        ),
      ];
      datelist.sort((a, b) => {
        return new Date(a) - new Date(b);
      });
      unique = [
        ...new Set(
          this.ricefarm.ricefarmlist.items.map((item) => item.RF_UNIT)
        ),
      ];

      if (unique.length > 0) {
        for (let i in unique) {
          let subunique = unique[i];
          let list1 = [];
          for (let j in this.ricefarm.ricefarmlist.items) {
            let subitem2 = this.ricefarm.ricefarmlist.items[j];

            if (
              this.ricefarm.periodselected == subitem2.RF_PERIOD &&
              this.ricefarm.townselected == subitem2.RF_TOWN &&
              subunique == subitem2.RF_UNIT
            ) {
              let avg = (subitem2.RF_PRICE_L + subitem2.RF_PRICE_H) / 2;
              let obj1 = {
                date: subitem2.RF_CDATE,
                avgprice: avg,
                volume: subitem2.RF_VOLUME,
              };
              list1.push(obj1);
            }
          }
          let obj2 = { name: subunique, data: list1 };
          mainlist.push(obj2);
        }
      }

      for (let k in mainlist) {
        let element1 = mainlist[k];
        let avglist = [],
          volumelist = [];

        for (let l in datelist) {
          let subdate = datelist[l];
          let subindex = element1.data.findIndex((x) => x.date == subdate);
          if (subindex != -1) {
            if (element1.data[subindex].avgprice == 0) avglist.push(null);
            else avglist.push(element1.data[subindex].avgprice);

            if (element1.data[subindex].volume == 0) volumelist.push(null);
            else volumelist.push(element1.data[subindex].volume);
          } else {
            avglist.push(null);
            volumelist.push(null);
          }
        }

        let volumeobj = {
          name: element1.name + "交易量",
          type: "column",
          data: volumelist,
        };

        serieslist.push(volumeobj);

        let avgobj = {
          name: element1.name + "平均價格",
          type: "line",
          data: avglist,
        };

        serieslist.push(avgobj);

        let volumeoption = {},
          avgoption = {};
        if (k == 0) {
          volumeoption = {
            seriesName: "交易量",
            title: {
              text: "交易量",
            },
          };

          avgoption = {
            seriesName: "平均價格",
            opposite: true,
            min: 0,
            title: {
              text: "價格 ( 元 / 公斤 )",
            },
          };
        } else {
          volumeoption = {
            seriesName: "交易量",
            show: false,
          };

          avgoption = {
            seriesName: "平均價格",
            min: 0,
            show: false,
          };
        }

        this.ricefarm.obj.chart.options.yaxis.push(volumeoption);
        this.ricefarm.obj.chart.options.yaxis.push(avgoption);
      }

      this.ricefarm.obj.chart.series = serieslist;
      this.ricefarm.obj.chart.series.forEach((x) => {
        x.data.unshift(null);
        x.data.push(null);
      });

      let labellist = [];

      for (let l in datelist) {
        let subdate3 = datelist[l].split("T")[0].split("-");
        subdate3[0] = parseInt(subdate3[0]) - 1911;
        labellist.push(subdate3.join("-"));
      }
      // labellist = datelist
      this.ricefarm.obj.chart.options.labels = labellist;

      //往前加一天
      let date1 = this.getnewdate(labellist[0], 0);
      this.ricefarm.obj.chart.options.labels.unshift(date1);

      //往前減一天
      let date2 = this.getnewdate(labellist[labellist.length - 1], 1);
      this.ricefarm.obj.chart.options.labels.push(date2);
      if (this.$refs.chart1ref != undefined) {
        this.$refs.chart1ref.updateSeries(this.ricefarm.obj.chart.series);
        this.$refs.chart1ref.updateOptions(this.ricefarm.obj.chart.options);
        // this.fruit.ifchartshow = false
      }
    },
    // createnewchart() {
    //     this.ricefarm.ifchartshow = true
    //     this.ricefarm.obj.chart.series = []
    //     this.ricefarm.obj.chart.options.labels = []
    //     this.ricefarm.obj.chart.options.yaxis = []
    //     this.ricefarm.obj.chart.options.chart.type = "line"
    //     let maintainlist = [], avgpricelist = [], datelist = [], serieslist = []

    //     for(let j in this.ricefarm.ricefarmlist.items)
    //     {
    //         let subitem = this.ricefarm.ricefarmlist.items[j]
    //         if(subitem.AM_SPEC == this.ricefarm.ricefarmlist.value.code && (this.ricefarm.averageprice || this.ricefarm.maintainprice))
    //         {
    //             let subdate = subitem.AM_DATE.split('T')[0].split('-')
    //             subdate[0] = subdate[0] - 1911
    //             datelist.push(subdate.join('-'))
    //             if(this.ricefarm.averageprice)
    //             {
    //                 let avgprice = ( subitem.AM_PRICE_L + subitem.AM_PRICE_R ) / 2
    //                 avgpricelist.push(avgprice)
    //             }

    //             if(this.ricefarm.maintainprice)
    //             {
    //                 maintainlist.push(subitem.AM_TRADE)
    //             }
    //         }
    //     }

    //     if(avgpricelist.length!=0 || maintainlist.length!=0)
    //     {
    //         if(avgpricelist.length!=0)
    //         {
    //             // avgpricelist.unshift(null)
    //             // avgpricelist.push(null)

    //             let avgobj = {
    //                 name: '成本均價',
    //                 type: 'line',
    //                 data: avgpricelist
    //             }
    //             serieslist.push(avgobj)

    //             let avgoption = {}

    //             if(maintainlist.length!=0)
    //             {
    //                 avgoption = {
    //                     seriesName: '成本均價',
    //                     opposite: true,
    //                     title:{
    //                             text: '價格 (元 /公斤 )'
    //                     }
    //                 }
    //             }
    //             else
    //             {
    //                 avgoption = {
    //                     seriesName: '成本均價',
    //                     title:{
    //                             text: '價格 (元 /公斤 )'
    //                     }
    //                 }
    //             }

    //             this.ricefarm.obj.chart.options.yaxis.push(avgoption)
    //         }

    //         if(maintainlist.length != 0)
    //         {
    //             // maintainlist.unshift(null)
    //             // maintainlist.push(null)

    //             if(avgpricelist.length == 0)
    //             {
    //                 this.ricefarm.obj.chart.options.chart.type = "bar"
    //             }

    //             let volumeobj = {
    //                 name: '嘉義縣交易行情價',
    //                 type: 'column',
    //                 data: maintainlist
    //             }
    //             serieslist.push(volumeobj)

    //             let volumeoption = {
    //                 seriesName: '交易量',
    //                 title:{
    //                         text: '價格 (元/公斤 )'
    //                     }
    //             }
    //             this.ricefarm.obj.chart.options.yaxis.push(volumeoption)
    //         }
    //         this.ricefarm.obj.chart.series = serieslist
    //         this.ricefarm.obj.chart.series.forEach((x) => {
    //             x.data.unshift(null)
    //             x.data.push(null )
    //         })

    //         this.ricefarm.obj.chart.options.xaxis.categories = datelist

    //         //往前加一天
    //         let date1 = this.getnewdate(datelist[0], 0)
    //         this.ricefarm.obj.chart.options.xaxis.categories.unshift(date1)

    //         //往前減一天
    //         let date2 = this.getnewdate(datelist[datelist.length - 1], 1)
    //         this.ricefarm.obj.chart.options.xaxis.categories.push(date2)
    //     }

    //     if(this.$refs.chart1ref!=undefined)
    //     {
    //         this.$refs.chart1ref.updateSeries(this.ricefarm.obj.chart.series)
    //         this.$refs.chart1ref.updateOptions(this.ricefarm.obj.chart.options)
    //     }
    //     this.ricefarm.ifchartshow = false
    // },
    twtimeparse(item) {
      let tt = item.split("-");
      tt[0] = parseInt(tt[0]) + 1911;
      return tt.join("-");
    },
    changetimeformat(time) {
      let tt = time.split("-");
      tt[0] = parseInt(tt[0]) - 1911;
      return tt.join("-");
    },
    getnewdate(date, index) {
      let firstdate = date.split("-");
      firstdate[0] = parseInt(firstdate[0]) + 1911;
      let subdate = new Date(firstdate.join("-"));
      if (index == 0) {
        subdate.setDate(subdate.getDate() - 1);
      } else {
        subdate.setDate(subdate.getDate() + 1);
      }
      let formatDate =
        parseInt(subdate.getFullYear()) -
        1911 +
        "-" +
        (subdate.getMonth() + 1) +
        "-" +
        subdate.getDate();
      return formatDate;
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`)
      // let y = ymd
      const weekday = date.getDay();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6;
    },
  },
};
</script>
